import { MAP_TYPES } from '@deck.gl/carto';

const SCHOOL_SOURCE_ID = 'schoolSource';

const source = {
  id: SCHOOL_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'bmpo-smartmetro-09142026',
  data: 'SELECT School_Name, School_Type, School_Address, School_City, School_Zip, geom FROM `us-con-gcp-npr-0000424-011325.diamond.Schools`',
};

export default source;
